import type { UserAddressType } from '@/features/user/domain/enums/UserAddressType'
import type { LngLatEntity } from '@/shared/entities/LngLatEntity'

export class OrderLiveAddressEntity {
  source?: LngLatEntity
  sourceName?: string | null
  destination?: LngLatEntity
  destinationName?: string | null
  homeNumber?: string | null
  addressDescription?: string | null
  addressType?: UserAddressType
  userLocationFarAwayFromUserAddress?: boolean
  estimatedDeliveryDuration?: number
}
